import * as types from './mutation_types'
import { Loading } from 'element-ui'

export default {
  callCategories: (context) => {
    if (context.getters.getCategoriesCnt < 1) {
      context.dispatch('loadCategories')
    }
  },
  loadCategories: (context) => {
    vm.$axios.get('/post_cates').then(rs => {
      context.commit(types.UPDATE_CATEGORIES, rs.data)
      rs.data
    })
  },
  callLatestPosts: (context) => {
    if (context.getters.getLatestPosts.total < 1) {
      context.dispatch('loadLatestPosts')
    }
  },
  loadLatestPosts: (context) => {
    const posts = context.getters.cloneData(context.getters.getLatestPosts)
    posts.loading = true
    context.commit(types.UPDATE_LATEST_POSTS, posts)
    const params = {params: {p: posts.page + 1, perPage: posts.perPage}}
    vm.$axios.get('/posts/recent', params).then(rs => {
      posts.loading = false
      posts.total = rs.data.total
      posts.page = rs.data.page
      posts.data = posts.data.concat(rs.data.data)
      context.commit(types.UPDATE_LATEST_POSTS, posts)
    })
  },
  callCatePosts: (context) => {
    if (!context.getters.getCatePosts || context.getters.getCatePosts.total < 1) {
      context.dispatch('loadCatePosts')
    }
  },
  loadCatePosts: (context) => {
    const idx = vm.$route.params.idx
    const key = `cate_${idx}`
    const posts = context.getters.cloneData(context.getters.getCatePosts)
    posts.loading = true
    context.commit(types.UPDATE_CATE_POSTS, {key: key, value: posts})
    const params = {params: {postCate: idx, p: posts.page + 1, perPage: posts.perPage}}
    vm.$axios.get('/posts/search', params).then(rs => {
      posts.loading = false
      posts.total = rs.data.total
      posts.page = rs.data.page
      posts.data = posts.data.concat(rs.data.data)
      context.commit(types.UPDATE_CATE_POSTS, {key: key, value: posts})
    })
  },
  setCurrentCate: (context) => {
    const idx = Number(vm.$route.params.idx)
    if (context.getters.getCurrentCate && context.getters.getCurrentCate.idx !== idx) {
      vm.$axios.get(`/post_cates/${idx}`).then(rs => {
        context.commit(types.UPDATE_CURRENT_CATE, rs.data)
      })
    }
  },
  callTagPosts: (context) => {
    if (!context.getters.getTagPosts || context.getters.getTagPosts.total < 1) {
      context.dispatch('loadTagPosts')
    }
  },
  loadTagPosts: (context) => {
    const tag = vm.$route.params.tag
    const key = `tag_${tag}`
    const posts = context.getters.cloneData(context.getters.getTagPosts)
    posts.loading = true
    context.commit(types.UPDATE_TAG_POSTS, {key: key, value: posts})
    const params = {params: {tag: tag, p: posts.page + 1, perPage: posts.perPage}}
    // vm.$axios.get('/posts/search', params).then(rs => {
    vm.$axios.get('/union/search', params).then(rs => {
      posts.loading = false
      posts.total = rs.data.total
      posts.page = rs.data.page
      posts.data = posts.data.concat(rs.data.data)
      context.commit(types.UPDATE_TAG_POSTS, {key: key, value: posts})
    })
  },
  callEditorPosts: (context) => {
    if (!context.getters.getEditorPosts || context.getters.getEditorPosts.total < 1) {
      context.dispatch('loadEditorPosts')
    }
  },
  loadEditorPosts: (context) => {
    const idx = vm.$route.params.idx
    const key = `editor_${idx}`
    const posts = context.getters.cloneData(context.getters.getEditorPosts)
    posts.loading = true
    context.commit(types.UPDATE_EDITOR_POSTS, {key: key, value: posts})
    const params = {params: {writer: idx, p: posts.page + 1, perPage: posts.perPage}}
    vm.$axios.get('/union/search', params).then(rs => {
      posts.loading = false
      posts.total = rs.data.total
      posts.page = rs.data.page
      posts.data = posts.data.concat(rs.data.data)
      context.commit(types.UPDATE_EDITOR_POSTS, {key: key, value: posts})
    })
  },
  setCurrentEditor: (context) => {
    const idx = vm.$route.params.idx
    vm.$axios.get(`/members/${idx}`).then(rs => {
      context.commit(types.UPDATE_CURRENT_EDITOR, rs.data)
    })
  },
  callSearchArticles: (context) => {
    if (!context.getters.getSearchArticles || context.getters.getSearchArticles.total < 1) {
      context.dispatch('loadSearchArticles')
    }
  },
  loadSearchArticles: (context) => {
    const keyword = vm.$route.params.keyword
    const key = `search_articles_${keyword}`
    const posts = context.getters.cloneData(context.getters.getSearchArticles)
    posts.loading = true
    context.commit(types.UPDATE_SEARCH_ARTICLES, {key: key, value: posts})
    const params = {params: {keyword: keyword, p: posts.page + 1, perPage: posts.perPage}}
    vm.$axios.get('/union/search/articles', params).then(rs => {
      posts.loading = false
      posts.total = rs.data.total
      posts.page = rs.data.page
      posts.data = posts.data.concat(rs.data.data)
      context.commit(types.UPDATE_SEARCH_ARTICLES, {key: key, value: posts})
    })
  },
  callSearchGalleries: (context) => {
    if (!context.getters.getSearchGalleries || context.getters.getSearchGalleries.total < 1) {
      context.dispatch('loadSearchGalleries')
    }
  },
  loadSearchGalleries: (context) => {
    const keyword = vm.$route.params.keyword
    const key = `search_galleries_${keyword}`
    const feeds = context.getters.cloneData(context.getters.getSearchGalleries)
    feeds.loading = true
    context.commit(types.UPDATE_SEARCH_GALLERIES, {key: key, value: feeds})
    const params = {params: {keyword: keyword, p: feeds.page + 1, perPage: feeds.perPage}}
    vm.$axios.get('/union/search/galleries', params).then(rs => {
      feeds.loading = false
      feeds.total = rs.data.total
      feeds.page = rs.data.page
      feeds.data = feeds.data.concat(rs.data.data)
      context.commit(types.UPDATE_SEARCH_GALLERIES, {key: key, value: feeds})
    })
  },
  callRegionCountries: (context) => {
    if (context.getters.getRegionCountriesCnt < 1) {
      context.dispatch('loadRegionCountries')
    }
  },
  loadRegionCountries: (context) => {
    vm.$axios.get('/region_countries').then(rs => {
      context.commit(types.UPDATE_REGION_COUNTRIES, rs.data)
    })
  },
  callBrands: (context) => {
    if (context.getters.getBrandsCnt < 1) {
      context.dispatch('loadBrands')
    }
  },
  loadBrands: (context) => {
    vm.$axios.get('/brands').then(rs => {
      context.commit(types.UPDATE_BRANDS, rs.data)
    })
  },
  callTournaments: (context) => {
    if (!context.getters.isExistSameKeyTournament) {
      context.dispatch('loadTournaments')
    }
  },
  loadTournaments: (context) => {
    const query = context.getters.cloneData(vm.$route.query)
    let loading
    vm.$nextTick(() => loading = Loading.service({target: document.querySelector('#tournament_results')}))
    vm.$axios.get('/tournaments',{params: query}).then(rs => {
      context.commit(types.UPDATE_TOURNAMENTS, {key: context.getters.makeKey(query), value: rs.data})
      vm.$nextTick(() => loading.close())
    })
  },
  callUpcomingTournaments: (context) => {
    if (!context.getters.isExistUpcomingTournament) {
      context.dispatch('loadUpcomingTournaments')
    }
  },
  loadUpcomingTournaments: (context) => {
    vm.$axios.get('/tournaments/upcoming').then(rs => {
      context.commit(types.UPDATE_UPCOMING_TOURNAMENTS, rs.data)
    })
  },
  callEvents: (context) => {
    if (!context.getters.isExistSameKeyEvent) {
      context.dispatch('loadEvents')
    }
  },
  loadEvents: (context) => {
    const query = context.getters.cloneData(vm.$route.query)
    delete query.mode
    let loading
    vm.$nextTick(() => loading = Loading.service({target: document.querySelector('#event_results')}) )
    vm.$axios.get('/events',{params: query}).then(rs => {
      context.commit(types.UPDATE_EVENTS, {key: context.getters.makeKey(query), value: rs.data})
      vm.$nextTick(() => loading.close())
    })
  },
  callDatePeriod: (context) => {
    if (!context.getters.isExistDatePeriod) {
      vm.$axios.get('/tournaments/date/period').then(rs => {
        context.commit(types.UPDATE_DATE_PERIOD, rs.data)
      })
    }
  },
  callFeeds: (context) => {
    if (!context.getters.isExistFeedData) {
      context.dispatch('loadFeeds')
    }
  },
  loadFeeds: (context) => {
    let loading
    vm.$nextTick(() => loading = Loading.service({target: document.querySelector('#feed_results')}) )
    vm.$axios.get('/feeds').then(rs => {
      context.commit(types.UPDATE_FEEDS, rs.data)
      vm.$nextTick(() => loading.close())
    })
  },
  callSeries: async (context) => {
    if (!context.getters.isExistSeriesData) {
      await context.dispatch('loadSeries')
    }
  },
  loadSeries: async (context) => {
    let loading
    // vm.$nextTick(() => loading = Loading.service({target: document.querySelector('.series_results')}))
    await vm.$axios.get('/series').then(rs => {
      context.commit(types.UPDATE_SERIES, rs.data.data)
      // vm.$nextTick(() => loading.close())
    })
  },
  callAlbums: async (context) => {
    if (!context.getters.isExistAlbumData) {
      await context.dispatch('loadAlbums')
    }
  },
  loadAlbums: async (context, payload) => {
    let loading
    const params = {params: {}}
    // vm.$nextTick(() => loading = Loading.service({target: document.querySelector('.album_results')}))
    params.params.series_parameter = payload
    await vm.$axios.get('/albums', params).then(rs => {
      context.commit(types.UPDATE_ALBUMS, rs.data.data)
      // vm.$nextTick(() => loading.close())
    })
  },
  callAlbumImages: async (context) => {
    if (!context.getters.isExistAlbumImageData) {
      await context.dispatch('loadAlbumImages')
    }
  },
  loadAlbumImages: async (context, payload) => {
    let loading
    const params = {params: {}}
    vm.$nextTick(() => loading = Loading.service({target: document.querySelector('.album_image_results')}))
    if (payload.album_parameter) params.params.album_parameter = payload.album_parameter
    if (payload.keyword) params.params.keyword = payload.keyword
    await vm.$axios.get('/album_images', params).then(rs => {
      context.commit(types.UPDATE_ALBUM_IMAGES, rs.data.data)
      vm.$nextTick(() => loading.close())
    })
  },

  putListOfCalledAPI: (context, payload) => {
    context.commit(types.PUSH_LIST_OF_CALLED_API, payload)
  },
  setDisplayCateData: (context, payload) => {
    context.commit(types.UPDATE_DISPLAY_CATE_DATA, payload)
  },
  setDisplayData: (context, payload) => {
    context.commit(types.UPDATE_DISPLAY_DATA, payload)
  },
  setDisplayPage: (context, payload) => {
    context.commit(types.UPDATE_DISPLAY_PAGE, payload)
  },
  setToastBannerSmallSize: (context, payload) => {
    context.commit(types.CHANGE_SIZE_TOAST_BANNER, payload)
  },
  setOpenShareDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_SHARE_DIALOG, payload)
  },
  setOpenFooter1Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_FOOTER1_DIALOG, payload)
  },
  setOpenFooter2Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_FOOTER2_DIALOG, payload)
  },
  setOpenFooter3Dialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_FOOTER3_DIALOG, payload)
  },
  setOpenFaqDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_FAQ_DIALOG, payload)
  },
  setOpenTeamDialog: (context, payload) => {
    context.commit(types.CHANGE_OPEN_TEAM_DIALOG, payload)
  },
  setCurrentContentsData: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_CONTENTS_DATA, payload)
  },
}
